export default __webpack_public_path__ + "static/media/kband_logo_long.344cd007.png";